export default {
  title: JSON.parse(localStorage.getItem('title')) || [],
  gender: JSON.parse(localStorage.getItem('gender')) || [],
  ethnicity: JSON.parse(localStorage.getItem('ethnicity')) || [],
  religion: JSON.parse(localStorage.getItem('religion')) || [],
  marital_status: JSON.parse(localStorage.getItem('marital_status')) || [],
  place_of_birth: JSON.parse(localStorage.getItem('place_of_birth')) || [],
  citizenship: JSON.parse(localStorage.getItem('citizenship')) || [],

  states: JSON.parse(localStorage.getItem('states')) || [],
  cities: JSON.parse(localStorage.getItem('cities')) || [],
  postcodes: JSON.parse(localStorage.getItem('postcodes')) || [],
}
